import React from "react";
import { makeStyles } from "tss-react/mui";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { Box, Theme } from "@mui/material";
import { ExpiredWrapper } from "@shared/ExpiredWrapper";
import { LoadingBox } from "@shared/Loading";
import { PageContentWrapper } from "@shared/PageContentWrapper/PageContentWrapper";

import { useWorkspacePageLoading } from "./hooks/useWorkspacePageLoading";

const useStyles = makeStyles()((theme: Theme) => ({
    loading: {
        display: "flex",
        width: "100%",
        height: "80vh",
        alignItems: "center",
        justifyContent: "center",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        width: "100%",
    },
}));

type WorkspaceSubPageLayoutProps = {
    children: React.ReactNode;
    disableExpiredWrapper?: boolean;
};

export function WorkspaceSubPageLayout(props: WorkspaceSubPageLayoutProps) {
    const { classes } = useStyles();
    const isLoading = useWorkspacePageLoading();

    if (isLoading) {
        return (
            <PageContainer>
                <Box className={classes.loading}>
                    <LoadingBox sx={{ marginTop: 0 }} />
                </Box>
            </PageContainer>
        );
    }

    const content = (
        <PageContentWrapper size="xlarge" className={classes.content}>
            {props.children}
        </PageContentWrapper>
    );

    return <PageContainer>{props.disableExpiredWrapper ? content : <ExpiredWrapper>{content}</ExpiredWrapper>}</PageContainer>;
}
